import React from 'react';
import { NavLink } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import NavItem from '../NavItem/NavItem';

const NavItemBtn = ({
  title,
  path,
  icon,
}) => {
  return (
    <NavItem>
      <Tooltip title={title} placement="right">
        <NavLink to={`/console${path || ''}`} activeClassName="is_active">
          <IconButton classes={{ label: 'c-side-menu__button-label' }}>
            <img src={icon} alt={title} />
          </IconButton>
        </NavLink>
      </Tooltip>
    </NavItem>
  );
};

export default NavItemBtn;



// WEBPACK FOOTER //
// ./src/components/IterioApp/sideMenu/components/NavItemBtn/NavItemBtn.jsx